import { render, staticRenderFns } from "./EditableLabel.vue?vue&type=template&id=98d5e694&"
import script from "./EditableLabel.vue?vue&type=script&lang=js&"
export * from "./EditableLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports